module.exports = __webpack_public_path__ + "static/media/consultant-calendar.fb942e04.png";